import { NextSeo } from 'next-seo'

export const Head: React.FC = () => {
  return <NextSeo title="お墓・霊園探しならライフドット" noindex nofollow />
}
